import { ChangeDetectorRef, Component, Input, IterableDiffer, IterableDiffers, OnInit} from '@angular/core';
import { EventoUnidad} from "../../../../_models/evento-unidad";
import { UnidadEtapasService} from "../_services/unidad-etapas.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CustomAlertService} from "../../../../_components/custom-alert/custom-alert.service";
import { EstudioService} from "../../estudio.service";
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { Unidad } from 'src/app/_models/unidad';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
    selector: 'unidad-etapas-evidencias',
    standalone: false,
    templateUrl: 'unidad-etapas-evidencias.component.html',
    styleUrls: ['unidad-etapas-evidencias.component.scss','../../unidad-etapas/unidad-etapas-generales.scss']
})

export class UnidadEtapasEvidenciasComponent implements OnInit {

    @Input()
    _evidencias: any;
    evidencias: EventoUnidad[] = [];
    @Input()
    unidadID: number;
    @Input()
    isFamilia?: boolean = false;
    @Input()
    areas: any[];
    @Input()
    _unidad: Unidad;
    @Input()
    alumnoId: number;

    _tiposEvidencias;
    @Input()
    set tiposEvidencias(tiposEvidencias) {
        this._tiposEvidencias = tiposEvidencias.filter(item => item.tipo === 11);
    }
    _materias;
    @Input()
    set materias(materias) {
        this._materias = materias;
    }

    filterForm = new UntypedFormGroup({
        materias: new UntypedFormControl([]),
        evidenciasControl: new UntypedFormControl([])
    });

    filterFormEvidenciasSubscription: Subscription;
    filterFormMateriasSubscription: Subscription;

    evidenciasActivas = {};

    differ: IterableDiffer<any>;

    constructor(differs: IterableDiffers,
                private cd: ChangeDetectorRef,
                private unidadEtapasService: UnidadEtapasService,
                private customAlertService: CustomAlertService,
                private snackBar: MatSnackBar,
                private estudioService: EstudioService,
                private globalService: GlobalService
    ) {
        this.differ = differs.find([]).create(null);
    }

    ngOnInit() {
        this.estudioService.getEstudioServiceObservable().subscribe(data => {
            if (!data) {
                return false;
            }

            if (data.tipo == 'actualizar-lista-eventos') {
                let eventoIndice = this._evidencias.findIndex(ev => ev.id == data.eventoUnidad.id),
                    that = this;

                this._evidencias[eventoIndice] = data.eventoUnidad;
                this.updateView(this._evidencias);
            }
        });

        this.updateView(this._evidencias);
        // this._evidencias.map(evidenciaUnidad => {
        //     let evidenciaPush = new EventoUnidad(evidenciaUnidad);
        //     this.evidencias.push(evidenciaPush);
        // });
        this.filterForm.get('materias').valueChanges.subscribe(res => {
            this.updateView(this._evidencias);
        });

        this.filterForm.get('evidenciasControl').setValue(this._tiposEvidencias.map(item => item.id));

        this.filterFormEvidenciasSubscription = this.filterForm.get('evidenciasControl').valueChanges.pipe(
            startWith(
              this.filterForm.get('evidenciasControl').value
            )
          ).subscribe(
            res => {
              for (const key in this.evidenciasActivas) {
                if (Object.prototype.hasOwnProperty.call(this.evidenciasActivas, key)) {
                  this.evidenciasActivas[key] = false;
                }
              }
              res.forEach(element => {
                this.evidenciasActivas[element] = true;
              });
            }
          );
    }

    ngDoCheck() {
        const changes = this.differ.diff(this._evidencias);
        if (changes) {
            this.updateView(this._evidencias);
        }
    }

    updateView(evidencias) {
        this.filterForm.updateValueAndValidity();
        this.evidencias = evidencias.filter(this.filterFunction(this.filterForm, this)
        ).map(evidenciaUnidad => {
            if (this.evidencias.filter(filter => {
                filter.id == evidenciaUnidad.id
            }).length == 0) {
                return new EventoUnidad(evidenciaUnidad);
            }
        });
        const that = this;
        setTimeout(() => {
            that.cd.detectChanges();
        }, 250);
    }

    filterFunction(form: UntypedFormGroup, component) {
        return function(evidencia) {
            let areas = [];
            evidencia.metas.map(item => {
                if (item.areas) {
                    areas = component.globalService.unionArrays(areas, item.areas);
                }
            });
            return ( (areas.length > 0 ?
                component.globalService.intersectionArrays(areas.map(area => area.id), form.value.materias).length > 0 : false)
                || form.value.materias.length === 0);
        };
    }

    eliminarEvento(id) {
        let evidenciaIndex = this._evidencias.findIndex(evidencia => evidencia.evento.id == id);

        this.unidadEtapasService.quitarDeUnidad('evento', this.unidadID, id).subscribe(res => {
            this._evidencias.splice(evidenciaIndex, 1);
            this.updateView(this._evidencias);
            this.snackBar.open(`La evidencia ${id} se ha eliminado de la unidad satisfactoriamente.`, null, {duration: 2500})
        }, err => {
            this.customAlertService.setCustomMessage({
                tipo: 'error',
                texto: `No ha sido posible eliminar la evidencia de la unidad. <br> ${err.error} <br> Código de error: ${err.statusText}`
            });
        });
    }

}
